export const FILE_BASE_URL =
  "https://lsaswmuatapi.vmaxtechservices.help/swmp2images/";

// // Dev Base
export const API_BASE_URL1 = "https://dsh.vmaxtechservices.help/api/v1/";
export const API_BASE_URL3 = "https://dsh.vmaxtechservices.help/api/v2/";
export const API_BASE_URL = "https://dsh.vmaxtechservices.help/api/";

// export const API_BASE_URL1 = "http://localhost:7172/api/v1/";
// export const API_BASE_URL3 = "http://localhost:7172/api/v2/";
// export const API_BASE_URL = "http://localhost:7172/api/";


// Dev Tunel
// export const API_BASE_URL1 = "https://g62g9s9n-5250.inc1.devtunnels.ms/api/v1/";
// export const API_BASE_URL3 = "https://g62g9s9n-5250.inc1.devtunnels.ms/api/v2/";
// export const API_BASE_URL = "https://g62g9s9n-5250.inc1.devtunnels.ms/api/";


//production UAT URL
// export const API_BASE_URL1 ="https://uatlsaswmapi.lucknowswachhata.ass/v1/";
// export const API_BASE_URL3 ="https://uatlsaswmapi.lucknowswachhata.com/v2/";
// export const API_BASE_URL = "https://uatlsaswmapi.lucknowswachhata.com/";


// //production URL
// export const API_BASE_URL1 = "https://centraldelhi.swachhcity.com/DehliCentralApi/v1/";
// export const API_BASE_URL3 = "https://centraldelhi.swachhcity.com/DehliCentralApi/v2/";
// export const API_BASE_URL = "https://centraldelhi.swachhcity.com/DehliCentralApi/";




//GOOGLE MAP
// export const googleMapsApiKey11 = "AIzaSyAmek9bF8SnmFeUH4BvEffHYu_TuUieoDw";
export const googleMapsApiKey11 = "AIzaSyDGtz2gCqx0Cz3-9Fc1bhsxHC8G2kt1Ywk";
export const GOOGLE_MAPS_API_KEY = googleMapsApiKey11;
